import { Navbar } from '../../components/Navbar/Navbar'
import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { IGame } from '../../api/types/game'
import { queryGames } from '../../api/queries'
import { gamesQueryKey } from '../../api/queries'
import { fromAxiosError } from '../../context/GlobalError'
import { ErrorHandler } from '../../components/ErrorHandler/ErrorHandler'
import { Box, Container } from '@mui/material'
import { GameListEntry } from './components/GameListEntry/GameListEntry'
import { CreateGame } from './components/CreateGame/CreateGame'
import { useAuth } from '../../context/Auth'

export const GameList = () => {
  const { isLoading, error, data: games } = useQuery<IGame[]>(gamesQueryKey(), queryGames)
  const auth = useAuth()

  return (
    <>
      <Navbar />
      <ErrorHandler loading={isLoading} error={fromAxiosError(error)}>
        {auth && games && (
          <Container maxWidth="md">
            {(auth?.gm || auth?.admin) && (
              <Box sx={{ textAlign: 'right' }}>
                <CreateGame />
              </Box>
            )}

            {games.map(game => (
              <GameListEntry key={game.id} game={game} />
            ))}
          </Container>
        )}
      </ErrorHandler>
    </>
  )
}
